export function formatPlanDate(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)
  if (match === null) {
    return value
  }
  const year = match[1]
  const month = match[2]
  const day = match[3]
  if (
    typeof year !== 'string' ||
    typeof month !== 'string' ||
    typeof day !== 'string'
  ) {
    return value
  }
  return `${day}/${month}/${year}`
}

export function formatNoyoPlanLabel(plan: {
  name: string
  lineOfCoverage: string
  effectiveStartDate: string
  effectiveEndDate: string
}): string {
  if (plan.name.length === 0) {
    return ''
  }
  const dates = `(${formatPlanDate(plan.effectiveStartDate)}-${formatPlanDate(plan.effectiveEndDate)})`
  if (plan.lineOfCoverage.length > 0) {
    return `(${plan.lineOfCoverage})\n${plan.name}\n${dates}`
  }
  return `${plan.name}\n${dates}`
}

export function isoDateKey(value: string): string {
  const match = /^(\d{4}-\d{2}-\d{2})/.exec(value)
  if (match === null) {
    return ''
  }
  const key = match[1]
  return typeof key === 'string' ? key : ''
}

export type PlanDateMismatches = {
  surecoStartsBeforeNoyo: boolean
  surecoEndsAfterNoyo: boolean
}

export function planDateMismatches(
  sureco?: { effectiveStartDate: string; effectiveEndDate: string },
  noyo?: { effectiveStartDate: string; effectiveEndDate: string }
): PlanDateMismatches {
  if (sureco == null || noyo == null) {
    return { surecoStartsBeforeNoyo: false, surecoEndsAfterNoyo: false }
  }
  const surecoStart = isoDateKey(sureco.effectiveStartDate)
  const noyoStart = isoDateKey(noyo.effectiveStartDate)
  const surecoEnd = isoDateKey(sureco.effectiveEndDate)
  const noyoEnd = isoDateKey(noyo.effectiveEndDate)
  return {
    surecoStartsBeforeNoyo:
      surecoStart.length > 0 && noyoStart.length > 0 && surecoStart < noyoStart,
    surecoEndsAfterNoyo:
      surecoEnd.length > 0 && noyoEnd.length > 0 && surecoEnd > noyoEnd,
  }
}
